import toast from 'react-hot-toast'

// https://stackoverflow.com/a/18650249
export const blobToBase64 = (blob) => {
  return new Promise((resolve, _) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.readAsDataURL(blob)
  })
}

export const groupByKey = (key, arr) => {
  return arr.reduce((acc, cur) => {
    if (!acc[cur[key]]) acc[cur[key]] = []
    acc[cur[key]].push(cur)
    return acc
  }, {})
}

export const objectToFormData = (obj) => {
  let formData = new FormData()

  for (const key in obj) {
    formData.append(key, obj[key])
  }

  return formData
}

export const objectToUrlEncoded = (obj) => {
  let body = []

  for (const key in obj) {
    var encodedKey = encodeURIComponent(key)
    var encodedValue = encodeURIComponent(obj[key])
    body.push(encodedKey + '=' + encodedValue)
  }

  const ret = body.join('&')
  return ret
}

export const successToast = (msg) =>
  toast.success(msg, {
    position: 'bottom-center',
    duration: 3000,
    style: {
      borderRadius: '6px',
      background: '#333',
      color: '#fff',
      maxWidth: '600px'
    }
  })

export const errorToast = (msg) =>
  toast.error(msg, {
    position: 'bottom-center',
    duration: 3000,
    style: {
      borderRadius: '6px',
      background: '#333',
      color: '#fff',
      maxWidth: '600px'
    }
  })

export function removeDuplicates(arr, key) {
  const obj = {}
  arr.forEach((x) => (obj[x[key]] = x))
  return Object.values(obj)
}

/**
 * Extracts a comparable value from an enquiry based on the field name
 */
const getEnquirySortValue = (enquiry, field) => {
  switch (field) {
    case 'document':
      return Number(enquiry.Document) || 0
    case 'acctNo':
      return (enquiry.CustomerKeyCode || '').toString().toLowerCase()
    case 'acctName':
      return (enquiry.GarageName || '').toString().toLowerCase()
    case 'reg':
      return (enquiry.Reg || '').toString().toLowerCase()
    case 'status':
      return (enquiry.Status || '').toString().toLowerCase()
    case 'created':
      return new Date(enquiry.DatetimeCreated).getTime() || 0
    case 'modified':
      return new Date(enquiry.DatetimeModified || enquiry.DatetimeCreated).getTime() || 0
    default:
      return 0
  }
}

/**
 * Creates a comparator function for sorting enquiries
 */
export const createEnquiryComparator = (sortField, sortDirection) => {
  return (a, b) => {
    const valueA = getEnquirySortValue(a, sortField)
    const valueB = getEnquirySortValue(b, sortField)

    let result = 0

    if (typeof valueA === 'number' && typeof valueB === 'number') {
      result = valueA - valueB
    } else {
      result = valueA.toString().localeCompare(valueB.toString())
    }

    return sortDirection === 'asc' ? result : -result
  }
}

/**
 * Sorts an array of enquiries
 */
export const sortEnquiries = (enquiries, sortField, sortDirection) => {
  return enquiries.sort(createEnquiryComparator(sortField, sortDirection))
}
